import { call, put, takeEvery } from "redux-saga/effects";
import {
  GET_CURRENCY_DEFINITIONS,
  GET_CURRENCY_DEFINITIONS_SYNC,
  ADD_CURRENCY_DEFINITION,
  UPDATE_CURRENCY_DEFINITION,
  DELETE_CURRENCY_DEFINITION,
  
} from "./actionTypes"

import {

  getCurrencyListSuccess,
  getCurrencyListSuccessSync,
  addCurrencySuccess,
  updateCurrencySuccess,
  deleteCurrencySuccess,
  currencyApiError
  
} from "./actions"

//Include Both Helper File with needed methods
import {

addCurrency,
updateCurrency,
deleteCurrency,
getCurrencyList

} from "../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onGetCurrencyList() {
  try {
    const response = yield call(getCurrencyList)
    yield put(getCurrencyListSuccess(response))
  } catch (error) {
    yield put(currencyApiError(error))
  }
}

function* onGetCurrencyListSync() {
  try {
    const response = yield call(getCurrencyList)
    yield put(getCurrencyListSuccessSync(response))
  } catch (error) {
    yield put(currencyApiError(error))
  }
}

function* onAddCurrency({ payload: record }) {
  try {
    const response = yield call(addCurrency, record)
    yield put(addCurrencySuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(currencyApiError(error))
  }
}

function* onUpdateCurrency({ payload: record }) {
  try {
    const response = yield call(updateCurrency, record)
    yield put(updateCurrencySuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(currencyApiError(error))
  }
}

function* onDeleteCurrency({ payload: guid }) {
  try {
    const response = yield call(deleteCurrency, guid)
    yield put(deleteCurrencySuccess(response))
    toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(currencyApiError(error))
  }
}


function* currencyManagementSaga() {

    yield takeEvery(GET_CURRENCY_DEFINITIONS,onGetCurrencyList)
    yield takeEvery(GET_CURRENCY_DEFINITIONS_SYNC,onGetCurrencyListSync)
    yield takeEvery(ADD_CURRENCY_DEFINITION,onAddCurrency)
    yield takeEvery(UPDATE_CURRENCY_DEFINITION,onUpdateCurrency)
    yield takeEvery(DELETE_CURRENCY_DEFINITION,onDeleteCurrency)
}

export default currencyManagementSaga
